import { useEffect, useRef, useState } from "react";
import logo from "./logo.svg";
import "./App.scss";

import Routes from "./routes/Routes";

function App() {
  const [darkMode, setDarkMode] = useState(false);
  const initialized = useRef(false);

  useEffect(() => {
    const saved = localStorage.getItem("theme");

    if (saved === "dark") {
      setDarkMode(true);
      document.body.className = "dark";
    } else if (saved === "light") {
      setDarkMode(false);
      document.body.className = "";
    } else {
      // Sem nada salvo, detecta o tema do sistema
      const prefersDark = window.matchMedia(
        "(prefers-color-scheme: dark)"
      ).matches;
      setDarkMode(prefersDark);
      document.body.className = prefersDark ? "dark" : "";
    }

    setTimeout(() => {
      initialized.current = true;
    }, 0);
  }, []);

  useEffect(() => {
    if (!initialized.current) return;
    document.body.className = darkMode ? "dark" : "";
    localStorage.setItem("theme", darkMode ? "dark" : "light");
  }, [darkMode]);

  return <Routes darkMode={darkMode} setDarkMode={setDarkMode} />;
}

export default App;
